<template>
    <div>
        <MaSchd />
    </div>
</template>

<script>
import MaSchd from "./maSchdView.vue";
export default {
    components: {
        MaSchd,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
